export const isNewSticker = (sticker) =>
    [sticker?.slug, sticker?.name].some((value) => ["novo", "new"].includes(String(value ?? "").trim().toLowerCase()));

export const isFeaturedSticker = (sticker) =>
    [sticker?.slug, sticker?.name].some((value) => ["izdvajamo", "featured"].includes(String(value ?? "").trim().toLowerCase()));
